import React from 'react';
import clsx from 'clsx';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OCarouselTriptych as OCarouselTriptychComp } from '@marriott/mi-web-ui-kit';

const TEST_ID = 'designsystem-components-OCarouselTriptych';

export const OCarouselTriptychConfig = {
  emptyLabel: 'OCarouselTriptych',
  isEmpty: () => true,
  resourceType: 'mi-aem-utils/components/content/o-carousel-triptych',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OCarouselTriptych = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId, aImageMulti = [], imageOrientation, mContentHeader, mCarouselControls } = model;

  return (
    <div data-testid={TEST_ID} data-component-name="o-carousel-triptych" id={componentId} className={clsx(styleclass)}>
      <EditableComponent config={OCarouselTriptychConfig} {...props}>
        <OCarouselTriptychComp
          {...props}
          images={aImageMulti}
          imageOrientation={imageOrientation}
          mContentHeader={mContentHeader}
          mCarouselControls={mCarouselControls}
        />
      </EditableComponent>
    </div>
  );
};
